import { render, staticRenderFns } from "./EventsMap.vue?vue&type=template&id=1086cf8c"
import script from "./EventsMap.vue?vue&type=script&lang=js"
export * from "./EventsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports